import React from 'react'
import { Component, LocaleCode } from '../types/component'

interface SpacerProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function Spacer({ component }: SpacerProps) {
  const config = component.config as any
  const height = config.height || 40

  return (
    <div
      style={{
        height: `${height}px`,
        width: '100%',
      }}
    />
  )
}
